import clienteService from '../../services/cliente/ClienteService'

// O único estado realmente compartilhado aqui é o loading: quem chama usa a
// lista retornada pela action (AdminUsuarioForm) ou mantém a própria cópia local
// (CatalogLinkDialog, CatalogsListDialog).
export const clienteModule = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {
    async fetchClientes({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const response = await clienteService.getClientes(params)
        return (response && response.data) || []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    // Exact lookup by code. Kept out of the shared list: it resolves a value
    // already saved on a record, which may fall outside the limited page the
    // search returns.
    async findClienteByCodigo(context, codigo) {
      const response = await clienteService.getClientes({ codigo, limit: 1 })
      const clientes = (response && response.data) || []
      return clientes.length ? clientes[0] : null
    },
  },
  getters: {
    loadingClientes: (state) => state.loading,
  },
}
